import { inject, type InjectionKey } from 'vue';
import type {
  PlaceHolderComposable,
  PlaceHolderSealComposable
} from '@/composables/placement/placementTypes.ts';

export const PlaceHolderComposableKey: InjectionKey<PlaceHolderComposable> =
  Symbol('PlaceHolderComposableProvided');
export const PlaceHolderSealComposableKey: InjectionKey<PlaceHolderSealComposable> =
  Symbol('PlaceHolderSealComposableProvided');

export function injectStrict<T>(key: InjectionKey<T>, fallback?: T) {
  const resolved = inject(key, fallback);
  if (!resolved) {
    throw new Error(`Could not resolve ${key.description}`);
  }
  return resolved;
}
